/* eslint-disable */
// THIS FILE IS AUTO-GENERATED. DO NOT EDIT MANUALLY.
import { hc } from "hono/client";

import type { addresses as addressesApp } from "./src/routers/addresses";
import type { audit as auditApp } from "./src/routers/audit";
import type { auth as authApp } from "./src/routers/auth";
import type { calculations as calculationsApp } from "./src/routers/calculations";
import type { contacts as contactsApp } from "./src/routers/contacts";
import type { costCenters as cost_centersApp } from "./src/routers/cost-centers";
import type { crewDefinitions as crew_definitionsApp } from "./src/routers/crew-definitions";
import type { dashboard as dashboardApp } from "./src/routers/dashboard";
import type { dev as devApp } from "./src/routers/dev";
import type { documents as documentsApp } from "./src/routers/documents";
import type { emails as emailsApp } from "./src/routers/emails";
import type { files as filesApp } from "./src/routers/files";
import type { incomingInvoices as incoming_invoicesApp } from "./src/routers/incoming-invoices";
import type { insights as insightsApp } from "./src/routers/insights";
import type { integrations as integrationsApp } from "./src/routers/integrations";
import type { mailboxes as mailboxesApp } from "./src/routers/mailboxes";
import type { me as meApp } from "./src/routers/me";
import type { measurements as measurementsApp } from "./src/routers/measurements";
import type { mux as muxApp } from "./src/routers/mux";
import type { notes as notesApp } from "./src/routers/notes";
import type { organizations as organizationsApp } from "./src/routers/organizations";
import type { partnerships as partnershipsApp } from "./src/routers/partnerships";
import type { plan as planApp } from "./src/routers/plan";
import type { preferences as preferencesApp } from "./src/routers/preferences";
import type { projects as projectsApp } from "./src/routers/projects";
import type { protocols as protocolsApp } from "./src/routers/protocols";
import type { roles as rolesApp } from "./src/routers/roles";
import type { settings as settingsApp } from "./src/routers/settings";
import type { statistics as statisticsApp } from "./src/routers/statistics";
import type { stock as stockApp } from "./src/routers/stock";
import type { tasks as tasksApp } from "./src/routers/tasks";
import type { terminals as terminalsApp } from "./src/routers/terminals";
import type { testRouter as test_routerApp } from "./src/routers/test-router";
import type { tickets as ticketsApp } from "./src/routers/tickets";
import type { users as usersApp } from "./src/routers/users";
import type { utils as utilsApp } from "./src/routers/utils";
import type { vehicles as vehiclesApp } from "./src/routers/vehicles";
import type { videos as videosApp } from "./src/routers/videos";
import type { weather as weatherApp } from "./src/routers/weather";
import type { wiki as wikiApp } from "./src/routers/wiki";
import type { zero as zeroApp } from "./src/routers/zero";
export const createClient = (url: string, options?: Parameters<typeof hc>[1]) => ({
	addresses: hc<typeof addressesApp>(`${url}/addresses`, options),
	audit: hc<typeof auditApp>(`${url}/audit`, options),
	auth: hc<typeof authApp>(`${url}/auth`, options),
	calculations: hc<typeof calculationsApp>(`${url}/calculations`, options),
	contacts: hc<typeof contactsApp>(`${url}/contacts`, options),
	cost_centers: hc<typeof cost_centersApp>(`${url}/cost-centers`, options),
	crew_definitions: hc<typeof crew_definitionsApp>(`${url}/crew-definitions`, options),
	dashboard: hc<typeof dashboardApp>(`${url}/dashboard`, options),
	dev: hc<typeof devApp>(`${url}/dev`, options),
	documents: hc<typeof documentsApp>(`${url}/documents`, options),
	emails: hc<typeof emailsApp>(`${url}/emails`, options),
	files: hc<typeof filesApp>(`${url}/files`, options),
	incoming_invoices: hc<typeof incoming_invoicesApp>(`${url}/incoming-invoices`, options),
	insights: hc<typeof insightsApp>(`${url}/insights`, options),
	integrations: hc<typeof integrationsApp>(`${url}/integrations`, options),
	mailboxes: hc<typeof mailboxesApp>(`${url}/mailboxes`, options),
	me: hc<typeof meApp>(`${url}/me`, options),
	measurements: hc<typeof measurementsApp>(`${url}/measurements`, options),
	mux: hc<typeof muxApp>(`${url}/mux`, options),
	notes: hc<typeof notesApp>(`${url}/notes`, options),
	organizations: hc<typeof organizationsApp>(`${url}/organizations`, options),
	partnerships: hc<typeof partnershipsApp>(`${url}/partnerships`, options),
	plan: hc<typeof planApp>(`${url}/plan`, options),
	preferences: hc<typeof preferencesApp>(`${url}/preferences`, options),
	projects: hc<typeof projectsApp>(`${url}/projects`, options),
	protocols: hc<typeof protocolsApp>(`${url}/protocols`, options),
	roles: hc<typeof rolesApp>(`${url}/roles`, options),
	settings: hc<typeof settingsApp>(`${url}/settings`, options),
	statistics: hc<typeof statisticsApp>(`${url}/statistics`, options),
	stock: hc<typeof stockApp>(`${url}/stock`, options),
	tasks: hc<typeof tasksApp>(`${url}/tasks`, options),
	terminals: hc<typeof terminalsApp>(`${url}/terminals`, options),
	test_router: hc<typeof test_routerApp>(`${url}/test-router`, options),
	tickets: hc<typeof ticketsApp>(`${url}/tickets`, options),
	users: hc<typeof usersApp>(`${url}/users`, options),
	utils: hc<typeof utilsApp>(`${url}/utils`, options),
	vehicles: hc<typeof vehiclesApp>(`${url}/vehicles`, options),
	videos: hc<typeof videosApp>(`${url}/videos`, options),
	weather: hc<typeof weatherApp>(`${url}/weather`, options),
	wiki: hc<typeof wikiApp>(`${url}/wiki`, options),
	zero: hc<typeof zeroApp>(`${url}/zero`, options),
});

export type ApiClient = ReturnType<typeof createClient>;
